import { useTranslation } from "react-i18next";

export interface PillTabMenuProps {
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

export default function PillTabMenu({
  children,
  ariaLabel,
  className,
}: PillTabMenuProps) {
  const { t } = useTranslation("common");

  return (
    <nav
      className={`mt-4 flex space-x-4 ${className && className}`}
      aria-label={ariaLabel ?? t("Tabs")}
    >
      {children}
    </nav>
  );
}
